import {ConstructionTypeRequest, ConstructionTypeStructRequest, ConstructionTypeInteractor} from "../../Coordinator/ConstructionType/ConstructionTypeInteractor";

export class ConstructionTypeViewModel {
    private interactor: ConstructionTypeInteractor;

    constructor() {
        this.interactor = new ConstructionTypeInteractor();
    }

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new ConstructionTypeRequest(
            obj["sgeptipoconstrucao"] ? parseInt(obj["sgeptipoconstrucao"]) : 0,
            obj["nome"] ? obj["nome"] : "",
        )
        
        return new Promise((res, rej) => {  
            this.interactor.fetchSave(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new ConstructionTypeStructRequest(
            obj["sgeptipoconstrucao"] ? parseInt(obj["sgeptipoconstrucao"]) : 0
        )
        
        return new Promise((res, rej) => {
            this.interactor.fetchDataOne(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
}
